"use client";

import Link from "next/link";
import BlogTag from "../Blog/BlogTag/BlogTag";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";
import { getIcon } from "@litonarefin/utils/icons";
import { sanitize } from "@litonarefin/utils/miscellaneous";
import { getSourceSite } from "@litonarefin/utils/getSourceSite";

function jltWordCount(string, limit) {
  const words = string.split(" ");
  return words.slice(0, limit).join(" ");
}

export const FeaturedPostUpdate = ({ featuredPosts }) => {
  const siteSource = getSourceSite();
  const BLOG_PATH_PREFIX = siteSource === "wpadminify" ? "" : "/blog";

  return (
    <div className="jlt-blog-category shadow-custom jlt-mt-10 sm:jlt-mt-16 md:jlt-mt-24 jlt-py-4 jlt-p-4 sm:jlt-p-6 md:jlt-p-8 jlt-bg-white jlt-rounded-lg md:jlt-grid md:jlt-grid-cols-[1fr_1fr] jlt-gap-8">
      <div className="jlt-blog-category-preview">
        {featuredPosts?.[0]?.featured_image?.url ? (
          <div className="jlt-rounded-lg">
            <Link href={`${BLOG_PATH_PREFIX}/${featuredPosts?.[0]?.slug}/`}>
              <img
                src={featuredPosts?.[0]?.featured_image?.url}
                alt={featuredPosts?.[0]?.featured_image?.alt}
                width={1200}
                height={630}
                style={{
                  objectFit: "cover",
                }}
                className="jlt-rounded-lg"
              />
            </Link>
          </div>
        ) : null}
        <div className="jlt-blog-tag jlt-mt-8 jlt-flex jlt-items-center jlt-gap-4">
          {featuredPosts?.[0]?.categories?.map((cate, idx) =>
            cate?.slug ? (
              <BlogTag key={idx}>
                <Link href={`/category/${cate?.slug}`}>{cate?.name}</Link>
              </BlogTag>
            ) : null
          )}
          <div className="jlt-flex jlt-gap-2 jlt-items-center">
            {getStyledIcon(getIcon("clock"), "#98A2B3", "stroke")}
            <span className="jlt-text-sm jlt-text-[#98A2B3] jlt-font-semibold">
              {featuredPosts?.[0]?.reading_time} Min read
            </span>
          </div>
        </div>
        <Link href={`${BLOG_PATH_PREFIX}/${featuredPosts?.[0]?.slug}`}>
          <h2
            className="jlt-mt-4 jlt-text-lg sm:jlt-text-xl md:jlt-text-2xl jlt-text-[#1D2939] hover:jlt-text-[--primary] jlt-transition-all jlt-duration-200"
            dangerouslySetInnerHTML={{ __html: featuredPosts?.[0]?.title || "" }}
          />
        </Link>
        <div
          className="jlt-mt-6 jlt-text-base jlt-text-[#3F475A] jlt-font-normal"
          dangerouslySetInnerHTML={{
            __html: jltWordCount(sanitize(featuredPosts?.[0]?.excerpt || ""), 25),
          }}
        />
        <div className="jlt-mt-8">
          <Link
            href={`${BLOG_PATH_PREFIX}/${featuredPosts?.[0]?.slug}`}
            className="jlt-blog-more-btn jlt-inline-flex jlt-gap-2 jlt-items-center hover:jlt-gap-3 jlt-transition-all jlt-duration-300"
          >
            <span className="jlt-text-base jlt-text-[--primary] jlt-font-bold">Read More</span>
            {getIcon("largeArrowAlt")}
          </Link>
        </div>
      </div>

      <div className="jlt-blog-category-list jlt-flex jlt-flex-col jlt-gap-4 sm:jlt-gap-8 jlt-mt-8 md:jlt-mt-0">
        {featuredPosts?.slice(1, featuredPosts.length)?.map((featuredPost) => (
          <div
            key={featuredPost?.id}
            className={`${
              featuredPost?.featured_image.url
                ? "jlt-grid jlt-items-center sm:jlt-items-start jlt-grid-cols-[fit-content(30%)_1fr] lg:jlt-grid-cols-[fit-content(40%)_1fr] jlt-gap-6"
                : ""
            }  `}
          >
            {featuredPost?.featured_image.url ? (
              <div className="jlt-flex jlt-items-center sm:jlt-justify-center">
                <Link href={`${BLOG_PATH_PREFIX}/${featuredPost?.slug}/`}>
                  <img
                    src={featuredPost?.featured_image.url}
                    alt={featuredPost?.featured_image.alt}
                    width={220}
                    height={116}
                    style={{
                      objectFit: "cover",
                    }}
                    className="jlt-rounded-md jlt-w-full sm:jlt-w-[220px]"
                  />
                </Link>
              </div>
            ) : null}
            <div className="jlt-mt-0 sm:jlt-mt-4">
              {/* <div className="sm:jlt-flex jlt-items-center jlt-gap-2 jlt-hidden">
                                    {featuredPost?.[
                                        `${siteSource}PostCategories`
                                    ]?.nodes?.map((cate, idx) => (
                                        <BlogTag key={idx}>
                                            <Link
                                                href={`/category/${lowerCaseWithOutSpace(
                                                    cate?.name
                                                )}`}>
                                                {cate?.name}
                                            </Link>
                                        </BlogTag>
                                    ))}
                                </div> */}
              <Link href={`${BLOG_PATH_PREFIX}/${featuredPost?.slug}`}>
                <h3
                  className="jlt-text-sm md:jlt-text-sm lg:jlt-text-base jlt-leading-5 jlt-text-[#1D2939] hover:jlt-text-[--primary] jlt-transition-all jlt-duration-200"
                  dangerouslySetInnerHTML={{ __html: featuredPost?.title || "" }}
                />
              </Link>

              <div className="jlt-mt-2 jlt-hidden sm:jlt-flex jlt-gap-2 jlt-items-center">
                {getStyledIcon(getIcon("clock"), "#98A2B3", "stroke")}
                <span className="jlt-text-sm jlt-text-[#98A2B3] jlt-font-semibold">
                  {featuredPosts?.[0]?.reading_time} Min read
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
